/**
 * Utility functions for displaying reservation times
 * IMPORTANT: These functions only affect DISPLAY, never modify the database data
 */

const HOURS_OFFSET = 0; // No offset - display times as stored in database
const MILLISECONDS_PER_HOUR = 60 * 60 * 1000;

/**
 * Adjusts a date for display purposes only (currently no offset)
 * @param {Date|string} date - The original date
 * @returns {Date} - Adjusted date (for display only, does not modify original)
 */
export const adjustDateForDisplay = (date) => {
  if (!date) return null;
  const original = new Date(date);
  if (isNaN(original.getTime())) return null;
  return original; // Return original date without modification
};

/**
 * Formats date and time for display (as stored in database)
 * Format: "HH:MM DD.MM.YYYY"
 * @param {Date|string} date - The original date
 * @returns {string} - Formatted date string
 */
export const formatDateTimeForDisplay = (date) => {
  if (!date) return "N/A";
  const original = new Date(date);
  if (isNaN(original.getTime())) return "N/A";
  
  const day = String(original.getUTCDate()).padStart(2, '0');
  const month = String(original.getUTCMonth() + 1).padStart(2, '0');
  const year = original.getUTCFullYear();
  const hours = String(original.getUTCHours()).padStart(2, '0');
  const minutes = String(original.getUTCMinutes()).padStart(2, '0');
  
  return `${hours}:${minutes} ${day}.${month}.${year}`;
};

/**
 * Formats time only for display (as stored in database)
 * Format: "HH:MM"
 * @param {Date|string} date - The original date
 * @returns {string} - Formatted time string
 */
export const formatTimeForDisplay = (date) => {
  if (!date) return "00:00";
  const original = new Date(date);
  if (isNaN(original.getTime())) return "00:00";
  
  const hours = String(original.getUTCHours()).padStart(2, '0');
  const minutes = String(original.getUTCMinutes()).padStart(2, '0');
  
  return `${hours}:${minutes}`;
};

/**
 * Formats date only for display (as stored in database)
 * Format: "DD.MM.YYYY"
 * @param {Date|string} date - The original date
 * @returns {string} - Formatted date string
 */
export const formatDateForDisplay = (date) => {
  if (!date) return "N/A";
  const original = new Date(date);
  if (isNaN(original.getTime())) return "N/A";
  
  const day = String(original.getUTCDate()).padStart(2, '0');
  const month = String(original.getUTCMonth() + 1).padStart(2, '0');
  const year = original.getUTCFullYear();
  
  return `${day}.${month}.${year}`;
};
